import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { useAddItemToCart } from "../../../queries/useAddItemToCart";
import { useGetNewCart } from "../../../queries/useGetNewCart";
import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { useCartClear } from "../../../stores/hooks/useCartClear";
import { useNullableDealerAccountInfo } from "../../../stores/hooks/useNullableDealerAccountInfo";
import { Button, PrimaryButton } from "../../../ui/Button/Button";

export const Footer: FunctionComponent<{
  hide: VoidFunction;
  packageToCopy?: PackagePartItem;
}> = ({ hide, packageToCopy }) => {
  const { t } = useTranslation();
  const clearCart = useCartClear();
  const getNewCart = useGetNewCart();
  const addItemToCart = useAddItemToCart();
  const dealer = useNullableDealerAccountInfo();
  const [isDuplicating, setIsDuplicating] = useState(false);
  return (
    <footer className="new-package-dialog__footer">
      <Button aria-label="close" onClick={hide}>
        {t("packageEditor.close")}
      </Button>
      <PrimaryButton
        onClick={async (): Promise<void> => {
          if (!packageToCopy) {
            return;
          }
          setIsDuplicating(true);
          try {
            clearCart();
            const newCart = await getNewCart();
            const input = packageToCopy.partDetails.primaryPart.packageItem.map(
              (item) => ({
                dealerId: Number(dealer?.dealerId ?? 0),
                itemId: item.itemId,
                itemType: item.itemType,
                orderNumber: newCart.orderNumber,
                partStock: [],
                pricingOption: {
                  context:
                    packageToCopy.partPricing.primaryPart.price[
                      item.itemQuantity
                    ].contextList[0],
                  quantity: item.itemQuantity,
                },
                vehicleId: null,
              })
            );
            await addItemToCart.send(input);
          } finally {
            setIsDuplicating(false);
          }
        }}
        aria-label="save"
        busy={isDuplicating}
      >
        {t("packageEditor.createQuote")}
      </PrimaryButton>
    </footer>
  );
};
